<template>
  <v-container>
    <v-card :elevation="10">
      <v-card-title>
        案件情報の入力
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>委託業務名</h3>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.title"
              outlined
              label="委託業務名"
              :error-messages="error.title"
              dense />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>協会審査員</h3>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.user_id2"
              outlined
              :items="users.filter(user => user.id === this.$store.state.auth.id)"
              :error-messages="error['users.1.id']"
              item-value="id"
              item-text="label"
              label="名前"
              menu-props="auto"
              hide-details
              readonly
              dense />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>協会審査員(代理)</h3>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.user_id3"
              outlined
              :items="users"
              :error-messages="error['users.2.id']"
              item-value="id"
              item-text="label"
              label="名前"
              menu-props="auto"
              hide-details
              dense />
          </v-col>
        </v-row>

        <v-row
          class="mt-5 pb-10"
          dense>
          <v-col
            cols="3"
            class="text-right pr-4 pt-3">
            <h3>主任調査員</h3>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.user_id1"
              outlined
              :items="users"
              :error-messages="error['users.0.id']"
              item-value="id"
              item-text="label"
              label="名前"
              menu-props="auto"
              hide-details
              dense />
          </v-col>
        </v-row>
      </v-card-text>
      <v-dialog
        v-model="modal"
        max-width="400px"
        persistent
        no-click-animation>
        <v-card>
          <v-card-title>確認</v-card-title>
          <v-card-text>
            <template v-if="modal">
              <v-alert
                dark
                outlined
                color="info">
                案件名「{{ form.title }}」を作成します。
              </v-alert>
              <ul>
                <li>
                  この情報は、
                  <span class="font-weight-bold">{{ userName1 }}</span>さん、
                  <span class="font-weight-bold">{{ userName2 }}</span>さん、
                  <template v-if="userName3">
                    <span class="font-weight-bold">{{ userName3 }}</span>さん
                  </template>
                  のみ編集が可能です。
                </li>
                <li>
                  承認は
                  <span class="font-weight-bold">{{ userName2 }}</span>
                  <template v-if="userName3">
                    <span class="font-weight-bold">{{ userName3 }}</span>
                  </template>
                  さんのみ実施可能です。
                </li>
              </ul>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="default"
              @click.prevent="onCancelClicked">
              キャンセル
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              @click.prevent="onCreateClicked">
              作成する
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <slot name="footer">
        <global-footer>
          <template #left>
            <v-btn
              large
              @click.prevent="onReturnClicked">
              <v-icon>mdi-chevron-left</v-icon>
              戻る
            </v-btn>
          </template>
          <template #right>
            <v-btn
              large
              color="primary"
              @click.prevent="onNextClicked">
              次へ
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
        </global-footer>
      </slot>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ConfirmationCreate',
  components: { },
  data() {
    return {
      form: {
        title: null,
        user_id1: null,
        user_id2: null,
        user_id3: null,
      },
      users: [],
      error: {},
      modal: false,
    }
  },
  computed: {
    userName1() {
      return this.users.filter(user => user.id === this.form.user_id1)[0].name
    },
    userName2() {
      return this.users.filter(user => user.id === this.form.user_id2)[0].name
    },
    userName3() {
      return this.form.user_id3
        ? this.users.filter(user => user.id === this.form.user_id3)[0].name
        : null
    },
  },
  mounted() {
    this.form.user_id2 = this.$store.state.auth.id
    this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      const { data } = await window.axios.get('/api/users')
      this.users = [
        {
          pivot: {},
          label: '-- 選択して下さい --',
          name: '',
          block_id: null,
          id: null,
        }, ...data.map(user => (
          {
            pivot: {
              role_id: 1,
              main_license_code: user.license1?.code,
              mobilephone: user.mobilephone,
              telephone: user.telephone,
            },
            label: `${user.name} (${user.block.name}ブロック)`,
            name: user.name,
            block_id: user.block_id,
            id: user.id,
          }
        )).sort((a, b) => {
          if (a.block_id === this.$store.state.auth.block_id) {
            return -1
          }
          return a.id > b.id ? 1 : -1
        })]
    },
    async validateItem(confirmed = false) {
      try {
        const user1 = this.users.filter(user => user.id === this.form.user_id1)[0] ?? { pivot: {} }
        user1.pivot.role_id = 1
        const user2 = this.users.filter(user => user.id === this.form.user_id2)[0] ?? { pivot: {} }
        user2.pivot.role_id = 2
        const users = [user1, user2]

        if (this.form.user_id3) {
          const user3 = this.users.filter(
            user => user.id === this.form.user_id3,
          )[0] ?? { pivot: {} }
          user3.pivot.role_id = 2
          users.push(user3)
        }

        const params = {
          confirmed,
          title: this.form.title,
          users,
        }
        await window.axios.post('/api/confirmations', params)
        this.error = {}
        return true
      } catch (e) {
        if (e.response.status === 422) {
          const { errors } = e.response.data
          if (Object.keys(errors).length === 1 && Object.prototype.hasOwnProperty.call(errors, 'confirmed')) {
            this.error = {}
            return true
          }
          this.error = errors
        }
      }
      return false
    },
    onReturnClicked() {
      this.$router.push({ name: 'index' })
    },
    async onNextClicked() {
      if (await this.validateItem()) {
        this.modal = true
      }
    },
    onCancelClicked() {
      this.modal = false
    },
    async onCreateClicked() {
      if (await this.validateItem(true)) {
        this.$router.push({ name: 'confirmationIndex' })
      }
    },
  },
}
</script>
